import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { MutableRefObject, useEffect, useRef, useState } from 'react';
import { GtmListNameType } from 'types/gtm';
import { ListedProductType } from 'types/product';
import { useGtmContext } from 'utils/Gtm/context/GtmProvider';
import { getGtmProductsListEvent, getNewGtmEcommerceEvent } from 'utils/Gtm/EventFactories';
import { gtmSafePushEvent } from 'utils/Gtm/Gtm';

export const useGtmProductListView = (
    products: ListedProductType[] | null,
    listName: GtmListNameType,
    parentInstanceNumberRef?: MutableRefObject<number>,
): number => {
    const wasViewedRef = useRef(false);
    const [instanceNumber, setInstanceNumber] = useState(parentInstanceNumberRef?.current ?? 0);
    const { url } = useDomainConfig();
    const { didPageViewRun } = useGtmContext();

    useEffect(() => {
        if (didPageViewRun && products !== null && !wasViewedRef.current) {
            wasViewedRef.current = true;

            if (parentInstanceNumberRef !== undefined) {
                parentInstanceNumberRef.current++;
                setInstanceNumber(parentInstanceNumberRef.current);
            }

            const event = getNewGtmEcommerceEvent('ec.products_list', true);
            event.ecommerce = getGtmProductsListEvent(
                products,
                listName + (parentInstanceNumberRef !== undefined ? ` ${parentInstanceNumberRef.current}` : ''),
                1,
                0,
                url,
            );
            gtmSafePushEvent(event);
        }
    }, [listName, products, url, parentInstanceNumberRef, didPageViewRun]);

    return instanceNumber;
};
